var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-responsive', {
    staticClass: "mx-auto overflow-visible",
    attrs: {
      "max-width": "1024px",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "headline text-start mt-8"
  }, [_vm.award._id ? _c('span', [_vm._v("메인 수상기업 수정")]) : _c('span', [_vm._v("메인 수상기업 등록")])]), _c('section', {
    staticClass: "mt-4"
  }, [_c('v-card', [_vm.award._id ? _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("순서")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.award.sequence,
      callback: function callback($$v) {
        _vm.$set(_vm.award, "sequence", $$v);
      },
      expression: "award.sequence"
    }
  })], 1)], 1)], 1) : _vm._e(), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("회사 이름")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.award.name,
      callback: function callback($$v) {
        _vm.$set(_vm.award, "name", $$v);
      },
      expression: "award.name"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("작성일")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.$dayjs(_vm.award.createdAt).format('YYYY-MM-DD HH:mm:ss'),
      "type": "datetime-local",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": function change(value) {
        return _vm.award.createdAt = _vm.$dayjs(value).toDate();
      }
    }
  }), _c('div', {
    staticClass: "text-caption primary--text"
  }, [_vm._v("* 작성일이 최신일수록 상단에 노출됩니다")])], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("링크")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "placeholder": "https://"
    },
    model: {
      value: _vm.award.link,
      callback: function callback($$v) {
        _vm.$set(_vm.award, "link", $$v);
      },
      expression: "award.link"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v(" 이미지 "), _c('div', [_vm._v("이미지사이즈 : 280x98(px)")])]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('div', [_vm.award.image ? [_c('v-layout', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": "",
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.award.image = null;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-close")])], 1)], 1), _c('v-card', {
    staticStyle: {
      "border-style": "dotted",
      "border-width": "2px"
    },
    attrs: {
      "outlined": "",
      "width": "100%"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.award.image.src,
      "height": "373",
      "contain": ""
    }
  })], 1)] : _c('v-sheet', {
    staticClass: "d-flex",
    staticStyle: {
      "border-style": "dotted",
      "border-width": "2px",
      "cursor": "pointer"
    },
    attrs: {
      "outlined": "",
      "width": "100%",
      "height": "373"
    },
    on: {
      "click": function click($event) {
        var _vm$$refs$image, _vm$$refs$image$$refs, _vm$$refs$image$$refs2, _vm$$refs$image$$refs3;
        (_vm$$refs$image = _vm.$refs.image) === null || _vm$$refs$image === void 0 ? void 0 : (_vm$$refs$image$$refs = _vm$$refs$image.$refs) === null || _vm$$refs$image$$refs === void 0 ? void 0 : (_vm$$refs$image$$refs2 = _vm$$refs$image$$refs.input) === null || _vm$$refs$image$$refs2 === void 0 ? void 0 : (_vm$$refs$image$$refs3 = _vm$$refs$image$$refs2.click) === null || _vm$$refs$image$$refs3 === void 0 ? void 0 : _vm$$refs$image$$refs3.call(_vm$$refs$image$$refs2);
      }
    }
  }, [_c('div', {
    staticClass: "ma-auto"
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "18"
    }
  }, [_vm._v("mdi-file-upload")]), _c('span', [_vm._v("업로드 (.jpg, .png)")])], 1)]), _c('v-spacer')], 2), _c('v-file-input', {
    ref: "image",
    staticClass: "d-none",
    on: {
      "change": function change(file) {
        return _vm.upload(file).then(function (res) {
          return _vm.$set(_vm.award, 'image', res);
        });
      }
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "auto",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue darken-1"
    },
    on: {
      "click": function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v("저장")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }